'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _promise = require('../helpers/promise');

var _adapterUtils = require('./adapterUtils');

var withOptions = function withOptions(options) {
  return new _promise.Promise(function (resolve) {
    var xhr = new XMLHttpRequest();

    if (options.error) {
      resolve((0, _adapterUtils.withResponseHandlers)((0, _adapterUtils.buildErrorResponse)(xhr, options.error.message, 'OPTIONSERROR'), options));
      return;
    }

    // the http request was done by a separate client and is being piped back
    // into this one for response handling
    if (options.externalResponse) {
      var fromExternalResponse = options.externalResponse instanceof XMLHttpRequest ? (0, _adapterUtils.buildResponse)(options.externalResponse) : Object.assign((0, _adapterUtils.buildResponse)(xhr), options.externalResponse);
      resolve((0, _adapterUtils.withResponseHandlers)(fromExternalResponse, options));
      return;
    }

    xhr.open(options.method || 'GET', options.url, true);

    if (typeof options.timeout === 'number') {
      xhr.timeout = options.timeout;
    }

    xhr.withCredentials = options.withCredentials;
    if (options.responseType) {
      xhr.responseType = options.responseType;
    }

    if (typeof options.withXhr === 'function') {
      options.withXhr(xhr);
    }

    Object.keys(options.headers || {}).forEach(function (headerName) {
      if (options.headers[headerName] !== false) {
        xhr.setRequestHeader(headerName, options.headers[headerName]);
      }
    });

    xhr.addEventListener('load', function () {
      return resolve((0, _adapterUtils.withResponseHandlers)((0, _adapterUtils.buildResponse)(xhr), options));
    });

    xhr.addEventListener('error', function () {
      return resolve((0, _adapterUtils.withResponseHandlers)((0, _adapterUtils.buildErrorResponse)(xhr, 'Network request failed', 'NETWORKERROR'), options));
    });

    xhr.addEventListener('timeout', function () {
      return resolve((0, _adapterUtils.withResponseHandlers)((0, _adapterUtils.buildErrorResponse)(xhr, 'Request timeout', 'TIMEOUT'), options));
    });

    xhr.addEventListener('abort', function () {
      return resolve((0, _adapterUtils.withResponseHandlers)((0, _adapterUtils.buildErrorResponse)(xhr, 'Request aborted', 'ABORT'), options));
    });

    xhr.send(typeof options.data === 'undefined' ? null : options.data);
  });
};

var handleRequestErrors = function handleRequestErrors(reason) {
  return _promise.Promise.reject((0, _adapterUtils.buildRequestError)(reason));
};

exports.default = function (optionMiddleware) {
  var client = function client(url, options) {
    return (0, _adapterUtils.withRetry)(_extends({}, options, { url: url }), function (o) {
      return optionMiddleware(o).catch(handleRequestErrors).then(_adapterUtils.withTracking).then(withOptions);
    }).then(_adapterUtils.trackSuccess, function (response) {
      return _promise.Promise.reject((0, _adapterUtils.trackFailureBasedOnErrorResponse)(response));
    });
  };

  var responseWithMethod = function responseWithMethod(method) {
    return function (url, options) {
      return client(url, _extends({}, options, { method: method }));
    };
  };
  var withMethod = function withMethod(method) {
    return function (url, options) {
      return responseWithMethod(method)(url, options).then(function (_ref) {
        var data = _ref.data;
        return data;
      });
    };
  };

  return Object.assign(client, {
    get: withMethod('GET'),
    post: withMethod('POST'),
    put: withMethod('PUT'),
    patch: withMethod('PATCH'),
    delete: withMethod('DELETE'),
    options: withMethod('OPTIONS'),
    getWithResponse: responseWithMethod('GET'),
    postWithResponse: responseWithMethod('POST'),
    putWithResponse: responseWithMethod('PUT'),
    patchWithResponse: responseWithMethod('PATCH'),
    deleteWithResponse: responseWithMethod('DELETE'),
    optionsWithResponse: responseWithMethod('OPTIONS')
  });
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/hub-http/static-1.117/js/adapters/promiseClient.js
// module id = 101
// module chunks = 0 1